import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const OdometerWrapperAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "odometer-wrapper" */ './odometer-wrapper'),
  componentName: 'OdometerWrapper',
});
